import { defineStore } from 'pinia'
import { toRefs } from 'vue'
import { createState, resetState } from './state'
import { createActions } from './actions'
import { createGetters } from './getters'

export const useSalesOrdersStore = defineStore('salesOrders', () => {
  const state = createState()
  const actions = createActions(state)
  const getters = createGetters(state)

  const $reset = () => {
    resetState(state)
  }

  return {
    // State (using toRefs to maintain reactivity)
    ...toRefs(state),
    // Actions
    ...actions,
    // Getters
    ...getters,
    // Reset
    $reset,
  }
})

export type { CreateSalesOrderData, UpdateSalesOrderData } from './actions'
